/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ valueText: NonNullable<unknown> }} Exercise_Personal_Strength_Curve_LabelInputs */

const en_us2_exercise_personal_strength_curve_label = /** @type {(inputs: Exercise_Personal_Strength_Curve_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Where lifters your age and weight stand; you are at ${i?.valueText}`)
};

const pt_br2_exercise_personal_strength_curve_label = /** @type {(inputs: Exercise_Personal_Strength_Curve_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Onde ficam os praticantes da sua idade e peso; você está em ${i?.valueText}`)
};

const es_419_exercise_personal_strength_curve_label = /** @type {(inputs: Exercise_Personal_Strength_Curve_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dónde están quienes entrenan con tu edad y peso; tú estás en ${i?.valueText}`)
};

const pt_pt2_exercise_personal_strength_curve_label = /** @type {(inputs: Exercise_Personal_Strength_Curve_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Onde ficam os praticantes da tua idade e peso; tu estás nos ${i?.valueText}`)
};

const fr_fr2_exercise_personal_strength_curve_label = /** @type {(inputs: Exercise_Personal_Strength_Curve_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Où se situent les pratiquants de ton âge et de ton poids ; tu es à ${i?.valueText}`)
};

const de_de2_exercise_personal_strength_curve_label = /** @type {(inputs: Exercise_Personal_Strength_Curve_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wo Trainierende in deinem Alter und mit deinem Gewicht stehen; du liegst bei ${i?.valueText}`)
};

const it_it2_exercise_personal_strength_curve_label = /** @type {(inputs: Exercise_Personal_Strength_Curve_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dove si collocano le persone della tua età e peso; tu sei a ${i?.valueText}`)
};

/**
* | output |
* | --- |
* | "Where lifters your age and weight stand; you are at {valueText}" |
*
* @param {Exercise_Personal_Strength_Curve_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_strength_curve_label = /** @type {((inputs: Exercise_Personal_Strength_Curve_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Strength_Curve_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_strength_curve_label(inputs)
	if (locale === "es-419") return es_419_exercise_personal_strength_curve_label(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_strength_curve_label(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_strength_curve_label(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_strength_curve_label(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_strength_curve_label(inputs)
	return en_us2_exercise_personal_strength_curve_label(inputs)
});
export { exercise_personal_strength_curve_label as "exercise-personal.strength_curve_label" }